<template>
  <list-table
    url="accdetail"
    title="حساب های تفضیلی"
    detailUrl="editAccDetail"
    newUrl="addAccDetail"
    :fields="fields"
    :params="params"
  ></list-table>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import TableShowData from "../../../components/table";
export default {
  name: "Detaileds",
  components: {
    "list-table": TableShowData,
  },
  data() {
    return {
      fields: [
        {
          key: "code",
          label: "کد تفضیلی",
        },
        {
          key: "name",
          label: "نام تفضیلی",
        },
      ],
      params: [
        {
          label: "نام تفضیلی",
          field: "name",
          type: "text",
        },
      ],
    };
  },
   mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "حساب های تفضیلی" }]);
  },
};
</script>